document.querySelectorAll('[data-open-newsletter-popup]').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add("newsletter-show");
      setTimeout(() => {
        document.body.classList.add("show-newsletter-image");
      }, 700);
    })
  })